<template>
  <div class="user-menu-wrapper" v-if="visible" @click="handleBackdropClick">
    <div class="user-menu" @click.stop>
      <div class="menu-header">
        <div class="user-info">
          <div class="user-avatar-small">
            <span>{{ userInitial }}</span>
          </div>
          <div class="user-details">
            <div class="user-name">{{ userName }}</div>
            <div class="user-email">{{ userEmail }}</div>
          </div>
        </div>
      </div>
      
      <div class="menu-divider"></div>
      
      <div class="menu-items">
        <router-link to="/account" class="menu-item" @click.native="close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>Account</span>
        </router-link>
        
        <router-link to="/snags" class="menu-item" @click.native="close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>Snag Coupons</span>
        </router-link>
        
        <router-link to="/wallet" class="menu-item" @click.native="close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
            <path d="M7 15h0M2 9.5h20"></path>
          </svg>
          <span>Wallet</span>
        </router-link>
        
        <div class="menu-item" @click="handleSettings">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M12 1v6m0 6v6m5.2-13.2l-4.2 4.2m0 6l4.2 4.2M23 12h-6m-6 0H1m18.2-5.2l-4.2 4.2m0 6l4.2 4.2"></path>
          </svg>
          <span>Settings</span>
        </div>
      </div>
      
      <div class="menu-divider"></div>
      
      <div class="menu-footer">
        <button class="logout-btn" @click="handleLogout">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>Log Out</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '../store/user.js'

export default {
  name: 'UserMenu',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userStore: userStore.state
    }
  },
  computed: {
    userName() {
      return this.userStore.user?.name || 'User'
    },
    userEmail() {
      return this.userStore.user?.email || 'user@example.com'
    },
    userInitial() {
      return this.userName.charAt(0).toUpperCase()
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleBackdropClick() {
      this.close()
    },
    handleSettings() {
      this.$toast('Settings coming soon...')
      this.close()
    },
    async handleLogout() {
      const confirmed = await this.$confirm('Are you sure you want to log out?')
      if (confirmed) {
        userStore.logout()
        this.close()
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.user-menu-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: transparent;
}

.user-menu {
  position: absolute;
  top: 60px;
  right: 20px;
  width: 280px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-header {
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar-small {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  flex-shrink: 0;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  font-size: 13px;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0;
}

.menu-items {
  padding: 8px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
}

.menu-item:hover {
  background: #f5f5f5;
}

.menu-item svg {
  flex-shrink: 0;
}

.menu-item span {
  font-size: 15px;
}

.menu-footer {
  padding: 8px 12px 12px;
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.logout-btn:hover {
  background: #cc0000;
}

.logout-btn svg {
  flex-shrink: 0;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .user-menu {
    right: 10px;
    width: calc(100% - 20px);
    max-width: 320px;
  }
}
</style>
